import * as Api from './api';
import { updateSettings, settingsError } from './settings';

export function selectShipment(id) {
  return { type: 'SELECT_SHIPMENT', id };
}

export function requestPending() {
  return { type: 'REQUEST_PENDING' };
}

export function requestFinished() {
  return { type: 'REQUEST_FINISHED' };
}

export function updateModelWithTracking(data) {
  return { type: 'UPDATE_MODEL', data };
}

export function fetchTrackingAction(trackingPageId, orderId, zipCode, language) {
  return withApiAction(() => Api.getTrackingPage(trackingPageId, orderId, zipCode, language));
}

export function fetchEmbeddedWidgetAction(embeddedWidgetId, orderId) {
  return withApiAction(() => Api.getEmbeddedWidgetPage(embeddedWidgetId, orderId));
}

function withApiAction(fetchApi) {
  return (dispatch) => {
    dispatch(requestPending());
    fetchApi()
      .then((data) => {
        dispatch(updateSettings({ ...data.settings, ...data.tracking }));

        if (data.tracking) {
          dispatch(updateModelWithTracking(data.tracking));
        }
      })
      .catch((error) => {
        // non 2XX response means that we failed to fetch tracking page settings
        dispatch(settingsError(error));
      })
      .finally(() => dispatch(requestFinished()));
  };
}
